var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 479,
    viewBox: "0 0 524 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.997 476.699C390.377 476.699 474.994 464.007 474.994 448.35C474.994 432.693 390.377 420 285.997 420C181.617 420 97 432.693 97 448.35C97 464.007 181.617 476.699 285.997 476.699Z",
    fill: "#F4F4F4",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.045 83.7442L171.273 202.517L185.986 268.474H420.555C424.357 268.474 427.663 265.911 428.572 262.192L469.651 93.9931C470.973 88.7033 466.923 83.6615 461.468 83.7442H282.5H280.045Z",
    fill: "#D7DBDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.986 268.474L159.454 309.056C148.709 325.587 160.529 347.407 180.2 347.407H458.989",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.668 28.8623H132.51L185.904 268.556H420.473C424.275 268.556 427.581 265.994 428.49 262.274L469.569 94.0755C470.891 88.7857 466.841 83.7439 461.386 83.8266H146.726",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0112 60.0224C47.0337 60.0224 60.0224 47.0337 60.0224 31.0112C60.0224 14.9888 47.0337 2 31.0112 2C14.9888 2 2 14.9888 2 31.0112C2 47.0337 14.9888 60.0224 31.0112 60.0224Z",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.396 445.682C243.418 445.682 256.407 432.693 256.407 416.67C256.407 400.648 243.418 387.659 227.396 387.659C211.374 387.659 198.385 400.648 198.385 416.67C198.385 432.693 211.374 445.682 227.396 445.682Z",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M391.544 448.161C407.567 448.161 420.556 435.172 420.556 419.15C420.556 403.127 407.567 390.139 391.544 390.139C375.522 390.139 362.533 403.127 362.533 419.15C362.533 435.172 375.522 448.161 391.544 448.161Z",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.152 223.345C287.152 211.856 296.492 202.517 307.981 202.517C319.47 202.517 328.809 211.856 328.809 223.345",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.903 170.695C272.974 170.695 277.896 165.773 277.896 159.702C277.896 153.631 272.974 148.709 266.903 148.709C260.832 148.709 255.91 153.631 255.91 159.702C255.91 165.773 260.832 170.695 266.903 170.695Z",
    fill: "#A5A4A5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M349.143 170.695C355.214 170.695 360.136 165.773 360.136 159.702C360.136 153.631 355.214 148.709 349.143 148.709C343.072 148.709 338.15 153.631 338.15 159.702C338.15 165.773 343.072 170.695 349.143 170.695Z",
    fill: "#A5A4A5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M508.66 8.77734V35.6396",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M495.189 22.25H522.134",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6094 117.632V144.577",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1387 131.104H93.0836",
    stroke: "#A5A4A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.b664630352de290bc648adb981d7666c.svg";
export { ForwardRef as ReactComponent };